import MultiText, { MultiTextSource } from '@api-consent/model/MultiText';
import { type MultiTextRenderOptions } from '@api-consent/model/MultiTextRenderOptions';

export default class ServiceProvider {
  id: string;
  title: MultiTextSource;
  brand: MultiTextSource;
  tenant: MultiTextSource;
  description: MultiTextSource;
  url: MultiTextSource;
  brandId?: string;

  constructor({
    id, title, brand, tenant, description, url, brandId,
  }: {
    id: string,
    title: MultiTextSource,
    brand: MultiTextSource,
    tenant: MultiTextSource,
    description: MultiTextSource,
    url: MultiTextSource,
    brandId?: string,
  }) {
    this.id = id;
    this.title = title;
    this.brand = brand;
    this.tenant = tenant;
    this.description = description;
    this.url = url;
    this.brandId = brandId;
  }

  getTitle(opts: MultiTextRenderOptions) {
    return MultiText.render(this.title, opts);
  }

  getBrand(opts: MultiTextRenderOptions) {
    return MultiText.render(this.brand, opts);
  }

  getTenant(opts: MultiTextRenderOptions) {
    return MultiText.render(this.tenant, opts);
  }

  getDescription(opts: MultiTextRenderOptions) {
    return MultiText.render(this.description, opts);
  }

  getUrl(opts: MultiTextRenderOptions) {
    return MultiText.render(this.url, opts);
  }
}
